<template>
  <div>
    <nav-bar hideBackButton />
    <child-register v-if="userIsAParent" :heading="true"></child-register>
    <div v-else class="mobile none-padding-mobile pt-4">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <first-time-skeleton />
          </template>
          <div>
            <initial-setup :modulesInfo="modulesInfo"></initial-setup>
          </div>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { getModulesInfo } from '@/onBoard/services';
import { NavBar } from '@/common/components';
import initialSetup from '@/onBoard/components/InitialSetup';
import childRegister from '@/auth/views/child/ChildRegister';
import FirstTimeSkeleton from '@/onBoard/components/skeletons/FirstTimeSkeleton';

export default {
  components: {
    NavBar,
    initialSetup,
    childRegister,
    FirstTimeSkeleton,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      modulesInfo: [],
      loading: true,
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
  },
  async mounted() {
    try {
      this.modulesInfo = await getModulesInfo();
      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  },
};
</script>
